// extracted by mini-css-extract-plugin
module.exports = {"filterBox":"Filters_filterBox__2mh8q","title":"Filters_title__386Yd","list":"Filters_list__pTyFg","item":"Filters_item__apZJg","isActiveItem":"Filters_isActiveItem__2DyJU"};